{
  "SET_NEW_PASSWORD": {
    "TITLE": "Definir nova senha",
    "PASSWORD": {
      "LABEL": "Senha",
      "PLACEHOLDER": "Senha",
      "ERROR": "A senha é muito curta."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirmar senha",
      "PLACEHOLDER": "Confirme a senha",
      "ERROR": "As senhas não coincidem."
    },
    "API": {
      "SUCCESS_MESSAGE": "Senha alterada com sucesso.",
      "ERROR_MESSAGE": "Não foi possível conectar ao servidor Woot. Por favor, tente novamente."
    },
    "CAPTCHA": {
      "ERROR": "Verificação expirada. Por favor, resolva o captcha novamente."
    },
    "SUBMIT": "Enviar"
  }
}
